<template>
  <thead
    v-if="tableHasSections.hasHeader"
    data-sb-regression="sb-table-expandable-header"
  >
    <tr v-if="$slots['sb-table-action-bar'] && showActionBar">
      <th
        id="sb-table-action-bar-header"
        :class="'expandable-rows-header-cell'"
      >
        <ExpandCollapseAllCell
          :table="table"
          :has-sub-selectable-table="subRowsTableSelectable ? true : false"
          :table-can-expand="tableCanExpand === null ? table.getCanSomeRowsExpand() : tableCanExpand"
          @row-selection-updated="onRowSelected"
        />
        <slot
          name="sb-table-action-bar"
          :rows="table.getSelectedRowModel()"
        />
      </th>
      <th
        v-for="column in table?.getAllColumns().length - 1"
        :key="column"
        scope="col"
      />
    </tr>
    <template v-else>
      <tr
        v-for="headerGroup in table?.getHeaderGroups()"
        :key="headerGroup.id"
        v-memo="[headerGroup]"
      >
        <th
          v-for="(header, index) in headerGroup.headers"
          :key="header.id"
          :colSpan="header.colSpan"
          :class="['expandable-rows-header-cell', header.column?.columnDef?.class?.header ?? '']"
          :style="{ width: header.getSize() + 'px' }"
          scope="col"
        >
          <div class="expandable-rows-header-cell-wrapper">
            <div class="expandable-rows-header-cell-name-section">
              <ExpandCollapseAllCell
                v-if="index === 0"
                :table="table"
                :has-sub-selectable-table="subRowsTableSelectable ? true : false"
                :table-can-expand="tableCanExpand === null ? table.getCanSomeRowsExpand() : tableCanExpand"
                @row-selection-updated="onRowSelected"
              />
              <div>
                <component
                  :is="header.column?.columnDef.header"
                  v-bind="columnEvents"
                  v-if="header.column?.columnDef?.isHeaderSFC"
                  :column="header.column"
                  :table="header.getContext().table"
                />
                <FlexRender
                  v-else-if="!header.isPlaceholder"
                  v-bind="columnEvents"
                  :render="header.column?.columnDef.header"
                  :props="header.getContext()"
                />
              </div>
            </div>
            <div class="expandable-rows-header-cell-sorting-section">
              <SbSortableTableHead
                v-if="header.column?.columnDef?.enableSorting"
                :api-sorting="apiSorting"
                :item="header.column.columnDef"
                @api-sort="emitApiSort"
              />
            </div>
          </div>
        </th>
      </tr>
    </template>
  </thead>
</template>
<script>
import { FlexRender } from '@tanstack/vue-table';
import ExpandCollapseAllCell from '@src/components/Table/components/SbTableExpandableRows/components/ExpandCollapseAllCell.vue';
import SbSortableTableHead from '@src/components/Table/components/SbSortableTableHead.vue';

export default {
  name: 'SbTableExpandableHeader',
  components: {
    FlexRender,
    ExpandCollapseAllCell,
    SbSortableTableHead,
  },
  props: {
    table: {
      type: Object,
      required: true,
    },
    tableHasSections: {
      type: Object,
      required: true,
    },
    columnEvents: {
      type: Object,
      required: true,
    },
    showActionBar: {
      type: Boolean,
      required: true,
    },
    tableCanExpand: {
      type: Boolean,
      required: true,
    },
    subRowsTableSelectable: {
      type: Boolean,
      required: true,
    },
    onRowSelected: {
      type: Function,
      required: true,
    },
    apiSorting: {
      type: Boolean,
      required: true,
    },
  },
  emits: [
    /**
    * Only emmited when apiSorting is true.
    */
    'api-sort',
  ],
  methods: {
    emitApiSort(item) {
      this.$emit('api-sort', item);
    },
  },
};
</script>
